import { useQuery } from '@apollo/client';
import {
    CITRIN_GET_ALL_JOBS_CANCELED_BY_TAXI_DRIVER_ID,
    GetAllJobsCanceledByTaxiDriverIdRequest,
    GetAllJobsCanceledByTaxiDriverIdResponse,
} from '..';
import { CanceledJobFetchInputMgt } from '../../shared/types';

export const useGetAllJobsCanceledByTaxiDriverIdQuery = (request: CanceledJobFetchInputMgt) => {
    const { data, previousData, error, loading, ...rest } = useQuery<
        GetAllJobsCanceledByTaxiDriverIdResponse,
        GetAllJobsCanceledByTaxiDriverIdRequest
    >(CITRIN_GET_ALL_JOBS_CANCELED_BY_TAXI_DRIVER_ID, {
        variables: { request },
        skip: !request?.id,
        fetchPolicy: 'network-only',
        //onCompleted: (data) => console.log('[MGT] Riders', data),
    });
    return {
        ...rest,
        loading,
        data: data?.CITRIN_MGT_getAllJobsCanceledByTaxiDriverId,
        previousData: previousData?.CITRIN_MGT_getAllJobsCanceledByTaxiDriverId,
    };
};
